import { render, staticRenderFns } from "./ChildSize.vue?vue&type=template&id=07bcca32&scoped=true&"
import script from "./ChildSize.vue?vue&type=script&lang=js&"
export * from "./ChildSize.vue?vue&type=script&lang=js&"
import style0 from "./ChildSize.vue?vue&type=style&index=0&id=07bcca32&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07bcca32",
  null
  
)

export default component.exports